import { render } from "./OrgCreateTeam.vue?vue&type=template&id=1e849606&scoped=true"
import script from "./OrgCreateTeam.vue?vue&type=script&lang=js"
export * from "./OrgCreateTeam.vue?vue&type=script&lang=js"

import "./OrgCreateTeam.vue?vue&type=style&index=0&id=1e849606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e849606"]])

export default __exports__